<template>
    <b-card>
        <b-card-body>
            <b-row>
                <b-col>
                    <label>MsgRefId:</label><br>
                    {{ message.MsgRefId }}                   
                </b-col>
                <b-col>
                    <label>Typ:</label><br>
                    {{ message.MsgType }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <b-card>
                        <b-card-header>Anrop: {{ GetDateFormatted(message.Received) }}
                            <clipboardbutton :value="message.Msg"></clipboardbutton>
                            <b-button size="sm" :variant="viewmode?'light':''" title="Textläge av/på" @click="viewmode = !viewmode"><b-icon
                            icon="textarea-t"></b-icon></b-button>
                        </b-card-header>
                        <b-card-body class="scroll">
                            <vue-json-pretty v-if="message && message.Msg && viewmode" :data="msg"
                                :showLineNumber="true" :collapsedOnClickBrackets="true" />
                            <v-jsoneditor v-if="message && message.Msg && !viewmode" :value="msg" :options="options"
                                :plus="true" :height="'640px'" @error="onError"></v-jsoneditor>
                        </b-card-body>
                    </b-card>
                </b-col>
                <b-col cols="6">
                    <div v-if="!message.Resp"><b>(Ej processat)</b></div>
                    <b-card v-if="message.Resp">
                        <b-card-header>Svar: {{ GetDateFormatted(message.Processed) }}
                            <clipboardbutton :value="message.Resp"></clipboardbutton>
                            <b-button size="sm" :variant="viewmodeResp?'light':''" title="Textläge av/på" @click="viewmodeResp = !viewmodeResp"><b-icon
                            icon="textarea-t"></b-icon></b-button>
                        </b-card-header>
                        <b-card-body class="scroll">
                            <vue-json-pretty v-if="message && message.Resp && viewmodeResp" :data="resp"
                                :showLineNumber="true" :collapsedOnClickBrackets="true" />
                            <v-jsoneditor v-if="message && message.Resp && !viewmodeResp" :value="resp" :options="options"
                                :plus="true" :height="'640px'" @error="onError"></v-jsoneditor>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import moment from "moment";
import clipboardbutton from "./../../components/clipboardbutton.vue";
// import MonacoEditor from "vue-monaco";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import VJsoneditor from 'v-jsoneditor/src/index';

export default {
    name: 'apimessagedetails',
    components: {
        clipboardbutton,
        VueJsonPretty,
        VJsoneditor
    },
    props: {
        message: Object,
    },
    created() {
        this.UpdateCurrent();
    },
    watch: {
        message: function () {
           this.UpdateCurrent();
        }
    },
    data() {
        return {
            work: {},
            msg: null,
            resp: null,
            viewmode: true,
            viewmodeResp: true,
            reqViewObject: true,
            respViewObject: true,
            maxDepth: 99,
            options: {
                "mode": "code",
                "search": true,
                onEditable: (path, field, value) => false,
            }
        }
    },
    methods: {
        GetDateFormatted(d) {
            return (d) ? moment(d).format("YYYY-MM-DD HH:mm:ss") : '';
        },
        UpdateCurrent() {
            this.msg = null;
            if (this.message.Msg)
                this.msg = JSON.parse(this.message.Msg);
            this.resp = null;
            if (this.message.Resp)
                this.resp = JSON.parse(this.message.Resp);
        }
    }
}
</script>
<style scoped>
.scroll {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>